module.exports = __webpack_public_path__ + "static/img/complete-icon-and-name.3f6aa37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/complete-icon-and-name.png
// module id = fIzA
// module chunks = 0